export default __webpack_public_path__ + "static/media/08.63c9bcc4.webp";